import { useContext } from "react";
import { CountryAndCurrencyUpdateContext } from "../customContext/countryAndCurrencyProvider";

export function useUpdateCountryAndCurrencyCtx(){
    const ctx = useContext(CountryAndCurrencyUpdateContext);
    if(!ctx){
        throw new Error('useUpdateCountryAndCurrencyCtx must be used within CountryAndCurrencyProvider context')
    };
    return ctx
}